import ReactController from '~/controllers/react_controller'
import AWSRDSMetricsCharts from '~/dashboard/aws_rds_metrics_charts'

export default class AWSRDSMetricsChartsController extends ReactController {
  static values = {
    organizationId: String,
    resourceId: String,
    dbInstanceClass: String,
    rdsEngine: String,
  }

  createComponent() {
    return (
      <AWSRDSMetricsCharts
        organizationId={this.organizationIdValue}
        resourceId={this.resourceIdValue}
        dbInstanceClass={this.dbInstanceClassValue}
        rdsEngine={this.rdsEngineValue}
      />
    )
  }
}
